
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.7 4.7L12 1.4H1.3l5.4 3.3zM12 9.3V2.6L6.7 5.9 1.4 2.6v6.7H12zM12 0c.4 0 .7.1.9.4.3.3.4.6.4.9v8c0 .4-.1.7-.4.9-.3.3-.6.4-.9.4H1.3c-.4 0-.7-.1-.9-.4-.3-.3-.4-.6-.4-.9v-8C0 .9.1.6.4.4.7.1 1 0 1.3 0H12z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#02203b"}})])
          )
        }
      }
    